document.addEventListener('alpine:init', () => {
    Alpine.store('tooltip', {
        show: false,
        type: 'default',
        x: 0,
        y: 0,
        maxWidth: 400,
        timeout: null,

        render(type, event = null) {
            this.type = type;
            this.show = true;
            if (event) this.updatePosition(event);
        },

        toggle(type, event) {
            if (this.show && this.type === type) {
                this.close();
            } else {
                this.render(type, event);
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => this.close(), 6000);
            }
        },

        close() {
            this.show = false;
            clearTimeout(this.timeout);
        },

        updatePosition(event) {
            const offset = 10;
            const tooltip = document.getElementById('info-window');
            if (!tooltip) return;

            let clientX, clientY;
            if (event.touches && event.touches.length > 0) {
                clientX = event.touches[0].clientX;
                clientY = event.touches[0].clientY;
            } else if (event.changedTouches && event.changedTouches.length > 0) {
                clientX = event.changedTouches[0].clientX;
                clientY = event.changedTouches[0].clientY;
            } else {
                clientX = event.clientX;
                clientY = event.clientY;
            }

            const rect = tooltip.getBoundingClientRect();
            let x = clientX - offset - this.maxWidth;
            let y = clientY - rect.height - offset;

            if (x + rect.width > window.innerWidth - offset) {
                x = clientX - rect.width - offset;
            }
            if (x < offset) {
                x = offset;
            }

            if (y < offset) {
                y = clientY + offset;
            }
            if (y + rect.height > window.innerHeight - offset) {
                y = window.innerHeight - rect.height - offset;
            }

            this.x = x;
            this.y = y;
        }
    });
});
